import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'pfhome';
export const route = 'pfhome/[searchId]/[fareItineraryKey]/[segmentKeys]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "pfhome" */
/* webpackPrefetch: true */
'../components/HomePage')));